var map = {
	"./a/advent.png": 185,
	"./a/adventcalendar.png": 24733,
	"./a/banner_img.png": 64630,
	"./b/chisel.png": 69777,
	"./b/softsettings.png": 34421,
	"./b/swirlyearrings.png": 54340,
	"./c/granulation.png": 96925,
	"./c/meltedbezel.png": 56155,
	"./c/rope.png": 96132,
	"./d/wax.png": 53683,
	"./e/tools.png": 72117,
	"./g/calendar.png": 12463,
	"./g/materialbox.png": 87561,
	"./g/newmaterialbox.png": 38372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41002;